import { render, staticRenderFns } from "./ArchiveSummary.vue?vue&type=template&id=20a95454&"
import script from "./ArchiveSummary.vue?vue&type=script&lang=js&"
export * from "./ArchiveSummary.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveSummary.vue?vue&type=style&index=0&id=20a95454&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports